import { render, staticRenderFns } from "./splitscreen.vue?vue&type=template&id=4fd82860&scoped=true&"
import script from "./splitscreen.vue?vue&type=script&lang=ts&"
export * from "./splitscreen.vue?vue&type=script&lang=ts&"
import style0 from "./splitscreen.vue?vue&type=style&index=0&id=4fd82860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd82860",
  null
  
)

export default component.exports